"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledListItem = void 0;
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
exports.StyledListItem = (0, styles_1.styled)(material_1.ListItem, {
    shouldForwardProp: prop => prop !== "wrap",
})(({ wrap, theme }) => ({
    flexWrap: wrap ? "wrap" : "nowrap",
    padding: theme.spacing(1, 0),
}));
//# sourceMappingURL=styled.js.map